import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { RouteSourcesEntity, RouteSourcesResponse, deserializeRouteSources } from 'src/entities/Timetable.entity';

import { COURSES_BASE_PATH } from './useCourses.query';

export const routeSourcesQueryKey = (courseId: number) => ['routeSources', courseId] as const;

/** ダイヤに入れるときのコピー元の候補。並びは他の画面操作で変わるので毎回取り直す（staleTime 0） */
export const useRouteSourcesQuery = (courseId: number | null) => useQuery<RouteSourcesEntity, Error>({
  queryKey: routeSourcesQueryKey(courseId ?? 0),
  queryFn: async () => deserializeRouteSources((await axios.get<RouteSourcesResponse>(`${COURSES_BASE_PATH}/${courseId}/route_sources`)).data),
  enabled: courseId != null,
  staleTime: 0,
});
